import React from 'react';

const HeaderTop = () => {
  return (
    <>
      <div className="row top-block align-items-center">
        <div className="col text-center">
          <div
            aria-label="welcome text"
            className="welcome-container"
            data-qa="welcome"
          >
            Hello There!
          </div>
        </div>
      </div>
      <style jsx>{`
        .top-block {
          padding-top: 10px;
        }
        .welcome-container {
          text-align: center;
          color: #5a266a;
          font-size: 12px;
          text-transform: capitalize;
          margin-left: 16%;
        }
        .advertise-link-container {
          text-align: center;
          font-size: 12px;
        }
        .advertise-link-container > a {
          text-decoration: none;
          color: #5a266a;
        }
      `}</style>
    </>
  );
};

export default HeaderTop;
